import { Component,ViewEncapsulation } from '@angular/core';
import { Globals } from './globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  constructor(public globals: Globals) { }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/app.component.ts